// <s-scroller>: scrolls its [data-track] by one page for --prev / --next commands and syncs the dot indicators.
class SScroller extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.addEventListener('command', (event) => {
      if (event.command === '--next') this.#page(1);
      if (event.command === '--prev') this.#page(-1);
    }, opts);
    // Older browsers ignore button commands, so wire the arrows with plain clicks there.
    if (!('commandForElement' in HTMLButtonElement.prototype) && this.id) {
      document.querySelectorAll(`button[commandfor="${this.id}"]`).forEach((button) => {
        button.addEventListener('click', () => {
          if (button.getAttribute('command') === '--next') this.#page(1);
          if (button.getAttribute('command') === '--prev') this.#page(-1);
        }, opts);
      });
    }
    this.#track()?.addEventListener('scroll', () => this.#sync(), { ...opts, passive: true });
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #track() {
    return this.querySelector('[data-track]');
  }

  #page(direction) {
    const track = this.#track();
    if (!track) return;
    const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: track.clientWidth * direction * rtl, behavior: reduced ? 'auto' : 'smooth' });
  }

  #sync() {
    const track = this.#track();
    // Count only the dots shown at this screen size.
    const dots = [...this.querySelectorAll('[data-dot]')].filter((dot) => dot.getClientRects().length > 0);
    if (!track || dots.length === 0) return;
    const max = Math.max(1, track.scrollWidth - track.clientWidth);
    const progress = Math.abs(track.scrollLeft) / max;
    const active = Math.round(progress * (dots.length - 1));
    dots.forEach((dot, i) => dot.toggleAttribute('data-active', i === active));
  }
}

if (!customElements.get('s-scroller')) customElements.define('s-scroller', SScroller);
